import { useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { getCustomForm } from '../../../../api/CustomForms';

export const useCustomForm = ({ params = {}, options = {}, dependencies = [] }) => {
  const navigate = useNavigate();

  return useQuery(['customForm', ...dependencies], () => getCustomForm(navigate, params), {
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    staleTime: Infinity,
    ...options
  });
};
